/**
 * Чистая (тестируемая без React/сети) логика колонок «заявка»/«встречный чат»
 * секции «Движения в боте» в `AuditChatModal.tsx` (задача 19, спека §5).
 * Джойн делает сервер (`GET /archive/ops`) — здесь только сборка ключа
 * обогащения и текст ячейки, никакой арифметики времени.
 */
import type { ArchiveOpsResponse, BotTxn } from '@wave/shared';

export type OpsEnrichmentEntry = ArchiveOpsResponse['enrichment'][string];

/**
 * Ключ обогащения — ровно те же три поля строки журнала, что собирает сервер
 * в `apps/api/src/modules/archive/enrich.ts` (`${externalTime}|${ccy}|${delta}`,
 * а `BotTxn.dateTime`/`amount` — то же самое после разбора ответа бота).
 */
export function botTxnOpsKey(t: Pick<BotTxn, 'dateTime' | 'ccy' | 'amount'>): string {
  return `${t.dateTime}|${t.ccy}|${t.amount}`;
}

export interface OpsCell {
  text: string;
  hint?: string;
}

const NO_DATE_HINT = 'выберите дату';

/** Колонка «заявка»: без выбранной даты обогащение не тянется (сервер отдаёт пусто). */
export function orderRefCell(date: string | null, entry: OpsEnrichmentEntry | undefined): OpsCell {
  if (!date) return { text: '—', hint: NO_DATE_HINT };
  return entry?.orderRef ? { text: `#${entry.orderRef}` } : { text: '—' };
}

/** Колонка «встречный чат»: название приоритетнее id (спека §5, `resolveChatTitle`). */
export function counterpartyCell(date: string | null, entry: OpsEnrichmentEntry | undefined): OpsCell {
  if (!date) return { text: '—', hint: NO_DATE_HINT };
  const label = entry?.counterpartyTitle ?? entry?.counterpartyChatId ?? null;
  return label ? { text: label } : { text: '—' };
}
